import { Icon } from '../icon.tsx';
import type { IconProps } from '../icon.tsx';

export function IconCircleCheck(props: IconProps) {
	return (
		<Icon stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" {...props}>
			<path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
			<path d="M9 12l2 2l4 -4" />
		</Icon>
	);
}
